import React, { useState, useRef } from 'react';
import {
    Box, Typography, TextField, Button, Grid, Paper, MenuItem,
    Divider, Select, InputLabel,
    useTheme, useMediaQuery, Fade, Zoom, Container, Stack, Alert, CircularProgress,
    Snackbar, FormControl, OutlinedInput, Checkbox, FormControlLabel
} from '@mui/material';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import SubjectIcon from '@mui/icons-material/School';
import GradeIcon from '@mui/icons-material/Grade';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';
import CategoryIcon from '@mui/icons-material/Category';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import DownloadIcon from '@mui/icons-material/Download';
import GenerateIcon from '@mui/icons-material/AutoFixHigh';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import AssignmentIcon from '@mui/icons-material/Assignment';
import BuildIcon from '@mui/icons-material/Build';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
//import axios from 'axios';
import api from '../axios/axiosInstance';
import html2pdf from 'html2pdf.js';
import { Document, Packer, Paragraph, TextRun, HeadingLevel, AlignmentType } from "docx";
import AIGenerationLimitDialog from '../dialogs/AIGenerationLimitDialog';
import ValidationErrorDialog from '../dialogs/ValidationErrorDialog';
import handleAIError from '../utils/handleAIError';
// useSubjectsAndUnits import removed
import { SpinningGradelyLoader, FloatingGradelyLoader } from '../loadingIcons/LoadingIcons';


const GRADES = ['K', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

const ACTIVITY_TYPES = [
    "Hands-on", "Group-based", "Inquiry-based", "Art-integrated", "Game/Competition",
    "Tech-based", "Outdoor", "Discussion-based", "Quiet/Independent",
    "Reading/Writing-based", "Movement-based"
];

const DOK_LEVELS = [1, 2, 3, 4];

const ActivityGenerator = ({ setActiveTabGlobal }) => {
    // Subject field removed
    const [grade, setGrade] = useState('');
    const [topic, setTopic] = useState('');
    const [activityType, setActivityType] = useState('');
    const [duration, setDuration] = useState('');
    const [loading, setLoading] = useState(false);
    const [activity, setActivity] = useState(null);
    const [error, setError] = useState('');
    const activityRef = useRef();

    const [gradeLevel, setGradeLevel] = useState('');
    ;
    const [activityTypes, setActivityTypes] = useState([]);
    const [dokLevels, setDokLevels] = useState([]);
    const [includeExtension, setIncludeExtension] = useState(false);
    const [response, setResponse] = useState(null);


    const [showLimitDialog, setShowLimitDialog] = useState(false);
    const [alertDialog, setAlertDialog] = useState({ open: false, message: "" });





    // Subject hooks removed
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const handleGenerate = async () => {
        if (!grade || !topic.trim() || !activityType || !duration) {
            setError("Please fill out all fields.");
            return;
        }
        
        if (!dokLevels || dokLevels.length === 0) {
            setError("Please select at least one DOK level.");
            return;
        }

        setLoading(true);
        setResponse(null);
        setError('');

        try {

            const res = await api.post(`${process.env.REACT_APP_BACKEND_URL}/grades/generate-activity/`, {
                grade_level: String(grade),
                topic,
                activity_types: activityType,
                include_extension: includeExtension,
                dok_levels: dokLevels,
                duration: duration
            }, { withCredentials: true });
            setActivity(res.data);
            setResponse(res.data);



        } catch (err) {
            handleAIError(err, { setErrorMsg: (msg) => setAlertDialog({ open: true, message: msg }), setShowLimitDialog });
        } finally {
            setLoading(false);
        }
    };

    const generatePDFHTML = (activityData) => {
        // Theme colors for PDF
        const primaryColor = '#546A2F'; // Theme main color
        const secondaryColor = '#A8B87C'; // Theme secondary color
        const successColor = '#2e7d32'; // Material-UI success green
        const infoColor = '#0288d1'; // Material-UI info blue
        const warningColor = '#ed6c02'; // Material-UI warning orange
        const errorColor = '#d32f2f'; // Material-UI error red
        const greyColor = '#757575'; // Material-UI grey
        const lightGreyColor = '#f5f5f5'; // Light grey background
        const borderColor = '#e0e0e0'; // Light border color

        const html = `
            <!DOCTYPE html>
            <html>
            <head>
                <meta charset="UTF-8">
                <title>Activity Plan - ${topic}</title>
            </head>
            <body style="font-family: 'Times New Roman', serif; margin: 0; padding: 0; line-height: 1.5; color: #212121; font-size: 11pt; background: white;">
                <div style="text-align: center; margin-bottom: 30px; border-bottom: 3px solid ${primaryColor}; padding-bottom: 15px;">
                    <div style="font-size: 20pt; font-weight: bold; margin-bottom: 8px; text-transform: uppercase; letter-spacing: 1px; color: ${primaryColor};">Activity Plan</div>
                    <div style="font-size: 12pt; font-weight: bold; margin-bottom: 5px; color: ${secondaryColor};">Grade ${grade}</div>
                </div>

                <div style="background: ${lightGreyColor}; border: 2px solid ${primaryColor}; padding: 15px; margin-bottom: 25px; border-radius: 8px;">
                    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
                        <div style="display: flex; justify-content: space-between; align-items: center; padding: 8px 0; border-bottom: 1px solid ${borderColor};">
                            <span style="font-weight: bold; color: ${primaryColor}; font-size: 10pt; text-transform: uppercase;">Grade:</span>
                            <span style="font-weight: bold; color: #212121; font-size: 10pt;">${grade}</span>
                        </div>
                        <div style="display: flex; justify-content: space-between; align-items: center; padding: 8px 0; border-bottom: 1px solid ${borderColor};">
                            <span style="font-weight: bold; color: ${primaryColor}; font-size: 10pt; text-transform: uppercase;">Topic:</span>
                            <span style="font-weight: bold; color: #212121; font-size: 10pt;">${topic}</span>
                        </div>
                        <div style="display: flex; justify-content: space-between; align-items: center; padding: 8px 0; border-bottom: 1px solid ${borderColor};">
                            <span style="font-weight: bold; color: ${primaryColor}; font-size: 10pt; text-transform: uppercase;">Activity Type:</span>
                            <span style="font-weight: bold; color: #212121; font-size: 10pt;">${activityType}</span>
                        </div>
                        <div style="display: flex; justify-content: space-between; align-items: center; padding: 8px 0; border-bottom: 1px solid ${borderColor};">
                            <span style="font-weight: bold; color: ${primaryColor}; font-size: 10pt; text-transform: uppercase;">Duration:</span>
                            <span style="font-weight: bold; color: #212121; font-size: 10pt;">${duration || 'N/A'}</span>
                        </div>
                    </div>
                </div>

                ${activityData.activity_title ? `
                    <div style="margin-bottom: 25px; page-break-inside: avoid;">
                        <div style="font-size: 14pt; font-weight: bold; color: ${primaryColor}; margin-bottom: 12px; padding-bottom: 3px; text-transform: uppercase; letter-spacing: 0.5px;">Activity Title</div>
                        <div style="background: white; border: 2px solid ${borderColor}; padding: 15px; margin-bottom: 15px; border-radius: 8px;">
                            <div style="font-size: 10pt; line-height: 1.4; text-align: justify; margin-bottom: 10px; color: #212121;">${activityData.activity_title}</div>
                        </div>
                    </div>
                ` : ''}

                ${activityData.activities ? `
                    <div style="page-break-inside: avoid;">
                        <div style="font-size: 14pt; font-weight: bold; color: ${primaryColor}; margin-bottom: 12px; padding-bottom: 3px; text-transform: uppercase; letter-spacing: 0.5px;">Activities</div>
                        <div style="background: white; border: 2px solid ${borderColor}; padding: 15px; margin-bottom: 15px; border-radius: 8px;">
                            ${activityData.activities.map((activity, index) => `
                                <div style="margin-bottom: 20px; padding-bottom: 15px; border-bottom: ${index < activityData.activities.length - 1 ? `2px solid ${borderColor}` : 'none'};">
                                    <div style="font-size: 12pt; font-weight: bold; color: ${secondaryColor}; margin-bottom: 8px; text-transform: uppercase; padding: 8px; background: ${lightGreyColor}; border-radius: 4px;">${activity.title}</div>
                                    
                                    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 8px; margin-bottom: 10px; font-size: 9pt; background: ${lightGreyColor}; padding: 10px; border-radius: 4px;">
                                        <div style="display: flex; justify-content: space-between;">
                                            <span style="font-weight: bold; color: ${primaryColor};">Type:</span>
                                        <span style="color: #212121;">${activityType}</span>
                                        </div>
                                        <div style="display: flex; justify-content: space-between;">
                                            <span style="font-weight: bold; color: ${primaryColor};">Time:</span>
                                            <span style="color: #212121;">${activity.time}</span>
                                        </div>
                                        <div style="display: flex; justify-content: space-between;">
                                            <span style="font-weight: bold; color: ${primaryColor};">DOK Level:</span>
                                            <span style="color: ${successColor}; font-weight: bold;">${activity.dok_level}</span>
                                        </div>
                                    </div>

                                    ${activity.materials && Array.isArray(activity.materials) ? `
                                        <div style="margin-bottom: 8px;">
                                            <div style="font-weight: bold; font-size: 9pt; margin-bottom: 4px; color: ${infoColor};">Materials:</div>
                                            <div style="padding-left: 15px;">
                                                ${activity.materials.map((material, idx) => `
                                                    <div style="margin-bottom: 4px; font-size: 9pt; position: relative;">
                                                        <span style="position: absolute; left: -10px; font-weight: bold; color: ${infoColor};">•</span>
                                                        <span style="margin-left: 5px; color: #212121;">${material}</span>
                                                    </div>
                                                `).join('')}
                                            </div>
                                        </div>
                                    ` : ''}

                                    ${activity.instructions && Array.isArray(activity.instructions) ? `
                                        <div style="margin-bottom: 8px;">
                                            <div style="font-weight: bold; font-size: 9pt; margin-bottom: 4px; color: ${warningColor};">Instructions:</div>
                                            <div style="padding-left: 15px;">
                                                ${activity.instructions.map((instruction, idx) => `
                                                    <div style="margin-bottom: 4px; font-size: 9pt; position: relative;">
                                                        <span style="position: absolute; left: -10px; font-weight: bold; color: ${warningColor};">•</span>
                                                        <span style="margin-left: 5px; color: #212121;">${instruction}</span>
                                                    </div>
                                                `).join('')}
                                            </div>
                                        </div>
                                    ` : ''}

                                    ${activity.extension ? `
                                        <div style="margin-bottom: 8px;">
                                            <div style="font-weight: bold; font-size: 9pt; margin-bottom: 4px; color: ${successColor};">Extension:</div>
                                            <div style="font-size: 9pt; padding-left: 15px; color: #212121;">${activity.extension}</div>
                                        </div>
                                    ` : ''}
                                </div>
                            `).join('')}
                        </div>
                    </div>
                ` : ''}
            </body>
            </html>
        `;
        return html;
    };

    const handleDownloadPDF = () => {
        if (!activity) return;

        const pdfHTML = generatePDFHTML(activity);
        const blob = new Blob([pdfHTML], { type: 'text/html' });
        const url = URL.createObjectURL(blob);

        const opt = {
            margin: [0.5, 0.5, 0.5, 0.5],
            filename: `Activity_Generator_${topic.replace(/\s+/g, '_')}.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: {
                scale: 2,
                useCORS: true,
                allowTaint: true,
                scrollX: 0,
                scrollY: 0
            },
            jsPDF: {
                unit: 'in',
                format: 'a4',
                orientation: 'portrait',
                compress: true
            },
            pagebreak: { mode: 'avoid-all' }
        };

        // Create a temporary iframe to render the HTML
        const iframe = document.createElement('iframe');
        iframe.style.position = 'absolute';
        iframe.style.left = '-9999px';
        iframe.style.top = '-9999px';
        iframe.style.width = '800px';
        iframe.style.height = '600px';
        document.body.appendChild(iframe);

        iframe.onload = () => {
            setTimeout(() => {
                html2pdf().set(opt).from(iframe.contentDocument.body).save().then(() => {
                    document.body.removeChild(iframe);
                    URL.revokeObjectURL(url);
                });
            }, 500);
        };

        iframe.src = url;
    };

    const generateWordDocument = async (activityData) => {
        // Theme colors for Word document (matching PDF colors)
        const primaryColor = '546A2F'; // Theme main color
        const secondaryColor = 'A8B87C'; // Theme secondary color
        const successColor = '2e7d32'; // Material-UI success green
        const infoColor = '0288d1'; // Material-UI info blue
        const warningColor = 'ed6c02'; // Material-UI warning orange
        const errorColor = 'd32f2f'; // Material-UI error red

        const doc = new Document({
            sections: [
                {
                    properties: {},
                    children: [
                        // Title
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: "ACTIVITY PLAN",
                                    bold: true,
                                    size: 40,
                                    color: primaryColor
                                })
                            ],
                            heading: HeadingLevel.TITLE,
                            alignment: AlignmentType.CENTER,
                            spacing: { after: 300 }
                        }),

                        // Subject and Grade Information
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: `Grade ${grade}`,
                                    bold: true,
                                    size: 24,
                                    color: secondaryColor
                                })
                            ],
                            alignment: AlignmentType.CENTER,
                            spacing: { after: 400 }
                        }),

                        // Activity Information Section
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: "ACTIVITY INFORMATION",
                                    bold: true,
                                    size: 28,
                                    color: primaryColor
                                })
                            ],
                            heading: HeadingLevel.HEADING_1,
                            spacing: { before: 300, after: 200 }
                        }),


                        // Grade
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: "Grade: ",
                                    bold: true,
                                    size: 22,
                                    color: primaryColor
                                }),
                                new TextRun({
                                    text: grade,
                                    size: 22
                                })
                            ],
                            spacing: { after: 100 }
                        }),

                        // Topic
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: "Topic: ",
                                    bold: true,
                                    size: 22,
                                    color: primaryColor
                                }),
                                new TextRun({
                                    text: topic,
                                    size: 22
                                })
                            ],
                            spacing: { after: 100 }
                        }),

                        // Activity Type
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: "Activity Type: ",
                                    bold: true,
                                    size: 22,
                                    color: primaryColor
                                }),
                                new TextRun({
                                    text: activityType,
                                    size: 22
                                })
                            ],
                            spacing: { after: 100 }
                        }),

                        // Duration
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: "Duration: ",
                                    bold: true,
                                    size: 22,
                                    color: primaryColor
                                }),
                                new TextRun({
                                    text: duration || 'N/A',
                                    size: 22
                                })
                            ],
                            spacing: { after: 400 }
                        }),

                        // Activity Title Section
                        ...(activityData.activity_title ? [
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: "ACTIVITY TITLE",
                                        bold: true,
                                        size: 28,
                                        color: primaryColor
                                    })
                                ],
                                heading: HeadingLevel.HEADING_1,
                                spacing: { before: 300, after: 200 }
                            }),
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: activityData.activity_title,
                                        size: 22
                                    })
                                ],
                                spacing: { after: 300 }
                            })
                        ] : []),

                        // Activities Section
                        ...(activityData.activities ? [
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: "ACTIVITIES",
                                        bold: true,
                                        size: 28,
                                        color: primaryColor
                                    })
                                ],
                                heading: HeadingLevel.HEADING_1,
                                spacing: { before: 300, after: 200 }
                            }),
                            ...activityData.activities.flatMap((activity, index) => [
                                new Paragraph({
                                    children: [
                                        new TextRun({
                                            text: activity.title,
                                            bold: true,
                                            size: 24,
                                            color: secondaryColor
                                        })
                                    ],
                                    spacing: { before: 200, after: 100 }
                                }),

                                // Activity Type, Time, DOK Level
                                new Paragraph({
                                    children: [
                                        new TextRun({
                                            text: "Type: ",
                                            bold: true,
                                            size: 20,
                                            color: primaryColor
                                        }),
                                        new TextRun({
                                            text: `${activityType} | `,
                                            size: 20
                                        }),
                                        new TextRun({
                                            text: "Time: ",
                                            bold: true,
                                            size: 20,
                                            color: primaryColor
                                        }),
                                        new TextRun({
                                            text: `${activity.time} | `,
                                            size: 20
                                        }),
                                        new TextRun({
                                            text: "DOK Level: ",
                                            bold: true,
                                            size: 20,
                                            color: primaryColor
                                        }),
                                        new TextRun({
                                            text: String(activity.dok_level || 'N/A'),
                                            size: 20,
                                            color: successColor
                                        })
                                    ],
                                    spacing: { after: 150 }
                                }),

                                // Materials
                                ...(activity.materials && Array.isArray(activity.materials) ? [
                                    new Paragraph({
                                        children: [
                                            new TextRun({
                                                text: "Materials:",
                                                bold: true,
                                                size: 20,
                                                color: infoColor
                                            })
                                        ],
                                        spacing: { before: 100, after: 50 }
                                    }),
                                    ...activity.materials.map(material =>
                                        new Paragraph({
                                            children: [
                                                new TextRun({
                                                    text: "• ",
                                                    bold: true,
                                                    size: 20,
                                                    color: infoColor
                                                }),
                                                new TextRun({
                                                    text: material,
                                                    size: 20
                                                })
                                            ],
                                            spacing: { after: 50 }
                                        })
                                    )
                                ] : []),

                                // Instructions
                                ...(activity.instructions && Array.isArray(activity.instructions) ? [
                                    new Paragraph({
                                        children: [
                                            new TextRun({
                                                text: "Instructions:",
                                                bold: true,
                                                size: 20,
                                                color: warningColor
                                            })
                                        ],
                                        spacing: { before: 100, after: 50 }
                                    }),
                                    ...activity.instructions.map(instruction =>
                                        new Paragraph({
                                            children: [
                                                new TextRun({
                                                    text: "• ",
                                                    bold: true,
                                                    size: 20,
                                                    color: warningColor
                                                }),
                                                new TextRun({
                                                    text: instruction,
                                                    size: 20
                                                })
                                            ],
                                            spacing: { after: 50 }
                                        })
                                    )
                                ] : []),

                                // Extension
                                ...(activity.extension ? [
                                    new Paragraph({
                                        children: [
                                            new TextRun({
                                                text: "Extension: ",
                                                bold: true,
                                                size: 20,
                                                color: successColor
                                            }),
                                            new TextRun({
                                                text: activity.extension,
                                                size: 20
                                            })
                                        ],
                                        spacing: { before: 100, after: 200 }
                                    })
                                ] : [])
                            ])
                        ] : []),

                        // Footer
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: "Generated by Gradely Educational Platform",
                                    size: 18,
                                    italics: true,
                                    color: "757575"
                                })
                            ],
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 600 }
                        })
                    ]
                }
            ]
        });

        return doc;
    };

    const downloadWordDocument = async (activityData) => {
        try {
            const doc = await generateWordDocument(activityData);
            const blob = await Packer.toBlob(doc);

            const element = document.createElement('a');
            element.href = URL.createObjectURL(blob);
            element.download = `Activity_Plan_${topic.replace(/\s+/g, '_')}.docx`;
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
            URL.revokeObjectURL(element.href);
        } catch (error) {
            console.error('Error generating Word document:', error);
            alert('Error generating Word document. Please try again.');
        }
    };

    const renderActivity = (activityData) => {
        if (!activityData) return null;

        return (
            <Fade in timeout={600}>
                <Box ref={activityRef}>
                    <Typography
                        variant={isSmallMobile ? "h6" : "h5"}
                        fontWeight="bold"
                        gutterBottom
                        sx={{
                            textAlign: 'center',
                            color: theme.palette.primary.main,
                            mb: 3,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 1
                        }}
                    >
                        <SportsEsportsIcon fontSize="small" />
                        Generated Activity Plan
                    </Typography>
                    <Divider sx={{ mb: 3 }} />

                    {/* Basic Information */}
                    <Paper
                        elevation={2}
                        sx={{
                            p: { xs: 2, sm: 3 },
                            mb: 4,
                            borderRadius: { xs: 1, sm: 1.5, md: 2 },
                            border: `1px solid ${theme.palette.divider}`,
                            backgroundColor: theme.palette.background.paper
                        }}
                    >
                        <Typography
                            variant="h6"
                            fontWeight="bold"
                            gutterBottom
                            sx={{
                                color: theme.palette.primary.main,
                                mb: 2,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1
                            }}
                        >
                            <AssignmentIcon fontSize="small" />
                            Activity Information
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2" sx={{ fontWeight: 'medium', display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <GradeIcon fontSize="small" color="primary" />
                                    <strong>Grade:</strong> {grade}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2" sx={{ fontWeight: 'medium', display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <EmojiObjectsIcon fontSize="small" color="primary" />
                                    <strong>Topic:</strong> {topic}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2" sx={{ fontWeight: 'medium', display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <CategoryIcon fontSize="small" color="primary" />
                                    <strong>Activity Type:</strong> {activityType}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2" sx={{ fontWeight: 'medium', display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <AccessTimeIcon fontSize="small" color="primary" />
                                    <strong>Duration:</strong> {duration}
                                </Typography>
                            </Grid>

                        </Grid>
                    </Paper>

                    {/* Activity Details */}
                    {activityData.activities ? (
                        activityData.activities.map((activity, index) => (
                            <Zoom in timeout={600 + index * 100} key={index}>
                                <Paper
                                    elevation={2}
                                    sx={{
                                        p: { xs: 2, sm: 3 },
                                        mb: 3,
                                        borderRadius: { xs: 1, sm: 1.5, md: 2 },
                                        border: `1px solid ${theme.palette.divider}`,
                                        transition: 'all 0.3s ease',
                                        '&:hover': {
                                            boxShadow: 4,
                                            transform: 'translateY(-2px)'
                                        }
                                    }}
                                >
                                    <Typography
                                        variant="h6"
                                        fontWeight="bold"
                                        sx={{
                                            mb: 2,
                                            color: theme.palette.primary.main,
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1
                                        }}
                                    >
                                        <DirectionsRunIcon fontSize="small" />
                                        {activity.title}
                                    </Typography>

                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="body2" sx={{ fontWeight: 'medium', display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <CategoryIcon fontSize="small" color="primary" />
                                                <strong>Type:</strong> {activityType}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="body2" sx={{ fontWeight: 'medium', display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <AccessTimeIcon fontSize="small" color="primary" />
                                                <strong>Time:</strong> {activity.time}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="body2" sx={{ fontWeight: 'medium', display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <BuildIcon fontSize="small" color="primary" />
                                                <strong>DOK Level:</strong> {activity.dok_level}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography variant="body2" sx={{ fontWeight: 'medium', mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <strong>Materials:</strong>
                                            </Typography>
                                            <Box component="ul" sx={{ pl: 2, m: 0 }}>
                                                {Array.isArray(activity.materials) && activity.materials.map((material, idx) => (
                                                    <Box component="li" key={idx} sx={{ mb: 1 }}>
                                                        <Typography variant="body2" sx={{ fontSize: isSmallMobile ? '0.875rem' : '1rem' }}>
                                                            {material}
                                                        </Typography>
                                                    </Box>
                                                ))}
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography variant="body2" sx={{ fontWeight: 'medium', mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <strong>Instructions:</strong>
                                            </Typography>
                                            <Box component="ul" sx={{ pl: 2, m: 0 }}>
                                                {Array.isArray(activity.instructions) && activity.instructions.map((instruction, idx) => (
                                                    <Box component="li" key={idx} sx={{ mb: 1 }}>
                                                        <Typography variant="body2" sx={{ fontSize: isSmallMobile ? '0.875rem' : '1rem' }}>
                                                            {instruction}
                                                        </Typography>
                                                    </Box>
                                                ))}
                                            </Box>
                                        </Grid>
                                        {activity.extension && (
                                            <Grid item xs={12}>
                                                <Typography variant="body2" sx={{ fontWeight: 'medium', mb: 1 }}>
                                                    <strong>Extension:</strong>
                                                </Typography>
                                                <Typography variant="body2" sx={{ fontSize: isSmallMobile ? '0.875rem' : '1rem' }}>
                                                    {activity.extension}
                                                </Typography>
                                            </Grid>
                                        )}
                                    </Grid>

                                </Paper>
                            </Zoom>
                        ))
                    ) : (
                        Object.entries(activityData).map(([key, value], index) => (
                            <Zoom in timeout={600 + index * 100} key={key}>
                                <Paper
                                    elevation={2}
                                    sx={{
                                        p: { xs: 2, sm: 3 },
                                        mb: 3,
                                        borderRadius: 3,
                                        border: `1px solid ${theme.palette.divider}`,
                                        transition: 'all 0.3s ease',
                                        '&:hover': {
                                            boxShadow: 4,
                                            transform: 'translateY(-2px)'
                                        }
                                    }}
                                >
                                    <Typography
                                        variant="subtitle1"
                                        fontWeight="bold"
                                        sx={{
                                            textTransform: 'capitalize',
                                            mb: 2,
                                            color: theme.palette.primary.main
                                        }}
                                    >
                                        {key.replace(/_/g, ' ')}
                                    </Typography>

                                    {typeof value === 'string' && (
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                whiteSpace: 'pre-wrap',
                                                lineHeight: 1.6,
                                                fontSize: isSmallMobile ? '0.875rem' : '1rem'
                                            }}
                                        >
                                            {value}
                                        </Typography>
                                    )}

                                    {Array.isArray(value) && (
                                        <Box component="ul" sx={{ pl: 2, m: 0 }}>
                                            {value.map((item, index) => (
                                                <Box component="li" key={index} sx={{ mb: 1 }}>
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            fontSize: isSmallMobile ? '0.875rem' : '1rem',
                                                            lineHeight: 1.6
                                                        }}
                                                    >
                                                        {item}
                                                    </Typography>
                                                </Box>
                                            ))}
                                        </Box>
                                    )}

                                    {typeof value === 'object' && !Array.isArray(value) && value !== null && (
                                        <Box sx={{ pl: 2 }}>
                                            {Object.entries(value).map(([subKey, subValue]) => (
                                                <Box key={subKey} sx={{ mb: 2 }}>
                                                    <Typography
                                                        variant="body2"
                                                        fontWeight="medium"
                                                        sx={{
                                                            color: theme.palette.secondary.main,
                                                            mb: 1
                                                        }}
                                                    >
                                                        {subKey.replace(/_/g, ' ')}:
                                                    </Typography>
                                                    {Array.isArray(subValue) ? (
                                                        <Box component="ul" sx={{ pl: 2, m: 0 }}>
                                                            {subValue.map((item, idx) => (
                                                                <Box component="li" key={idx} sx={{ mb: 1 }}>
                                                                    <Typography
                                                                        variant="body2"
                                                                        sx={{
                                                                            fontSize: isSmallMobile ? '0.875rem' : '1rem',
                                                                            lineHeight: 1.6
                                                                        }}
                                                                    >
                                                                        {item}
                                                                    </Typography>
                                                                </Box>
                                                            ))}
                                                        </Box>
                                                    ) : (
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                whiteSpace: 'pre-wrap',
                                                                lineHeight: 1.6,
                                                                fontSize: isSmallMobile ? '0.875rem' : '1rem'
                                                            }}
                                                        >
                                                            {subValue}
                                                        </Typography>
                                                    )}
                                                </Box>
                                            ))}
                                        </Box>
                                    )}
                                </Paper>
                            </Zoom>
                        ))
                    )}
                </Box>
            </Fade>
        );
    };

    return (
        <Container maxWidth="xl" sx={{ py: { xs: 2, sm: 3 } }}>
            <Fade in timeout={800}>
                <Box>
                    <Box sx={{ textAlign: 'center', mb: 2, mt: 0 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1.5, mb: 0.5 }}>

                            <Typography sx={{ fontSize: '2rem', fontWeight: 600, color: theme.palette.primary.main }}>
                                Generate Activities
                            </Typography>
                        </Box>
                    </Box>

                    <Typography sx={{ fontSize: '1rem', fontStyle: 'italic', textAlign: 'center', mb: 4, color: theme.palette.text.secondary, lineHeight: 1.6, maxWidth: '800px', mx: 'auto' }}>
                        Create customized learning activities by selecting a grade, topic, and activity type. Align activities with specific DOK levels to match your instructional goals.

                    </Typography>

                    {error && (
                        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError('')}>
                            {error}
                        </Alert>
                    )}
                    {/*Form starts here */}
                    <Paper
                        elevation={3}
                        sx={{
                            p: { xs: 2, sm: 3, md: 4 },
                            borderRadius: { xs: 1.5, sm: 2, md: 3 },
                            background: theme.palette.background.paper,
                            border: `1px solid ${theme.palette.divider}`
                        }}
                    >
                        <Stack spacing={3}>

                            <FormControl fullWidth>
                                <InputLabel>Grade</InputLabel>
                                <Select
                                    value={grade}
                                    label="Grade"
                                    onChange={(e) => setGrade(e.target.value)}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: 2
                                        }
                                    }}
                                >
                                    <MenuItem value="" disabled>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <GradeIcon fontSize="small" />
                                            Select a grade
                                        </Box>
                                    </MenuItem>
                                    {GRADES.map((g) => (
                                        <MenuItem key={g} value={g}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <GradeIcon fontSize="small" />
                                                Grade {g}
                                            </Box>
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <TextField
                                label="Topic"
                                fullWidth
                                value={topic}
                                onChange={(e) => setTopic(e.target.value)}
                                placeholder="e.g., Fractions on a Number Line"
                                InputProps={{
                                    startAdornment: <EmojiObjectsIcon sx={{ mr: 1, color: 'action.active' }} />
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: 2
                                    }
                                }}
                            />

                            <FormControl fullWidth>
                                <InputLabel>Activity Type</InputLabel>
                                <Select

                                    label="Activity Type"
                                    value={activityType}
                                    onChange={(e) => setActivityType(e.target.value)}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: 2
                                        }
                                    }}
                                >
                                    <MenuItem value="" disabled>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <CategoryIcon fontSize="small" />
                                            Select activity type
                                        </Box>
                                    </MenuItem>
                                    {ACTIVITY_TYPES.map((type) => (
                                        <MenuItem key={type} value={type}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <CategoryIcon fontSize="small" />
                                                {type}
                                            </Box>
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl fullWidth>
                                <InputLabel>Duration</InputLabel>
                                <Select
                                    value={duration}
                                    label="Duration"
                                    onChange={(e) => setDuration(e.target.value)}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: 2
                                        }
                                    }}
                                >
                                    <MenuItem value="" disabled>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <AccessTimeIcon fontSize="small" />
                                            Select duration
                                        </Box>
                                    </MenuItem>
                                    {["15 minutes", "30 minutes", "45 minutes", "1 hour", "1.5 hours", "2 hours", "Half day", "Full day"].map((dur) => (
                                        <MenuItem key={dur} value={dur}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <AccessTimeIcon fontSize="small" />
                                                {dur}
                                            </Box>
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <Box>
                                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                                    Select Applicable DOK Levels
                                </Typography>
                                <Box display="flex" flexWrap="wrap" gap={2}>
                                    {DOK_LEVELS.map((level) => (
                                        <FormControlLabel
                                            key={level}
                                            control={
                                                <Checkbox
                                                    checked={dokLevels.includes(level)}
                                                    onChange={(e) => {
                                                        const newLevels = e.target.checked
                                                            ? [...dokLevels, level]
                                                            : dokLevels.filter((l) => l !== level);
                                                        setDokLevels(newLevels);
                                                    }}
                                                />
                                            }
                                            label={`DOK ${level}`}
                                        />
                                    ))}
                                </Box>
                            </Box>

                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleGenerate}
                                disabled={loading}
                                size="large"
                                sx={{
                                    py: 1.5,
                                    borderRadius: 2,
                                    fontSize: '1.1rem',
                                    fontWeight: 'bold',
                                    backgroundColor: theme.palette.primary.main,
                                    '&:hover': {
                                        backgroundColor: theme.palette.primary.dark,
                                        transform: 'translateY(-2px)',
                                        boxShadow: 4
                                    }
                                }}
                            >
                                {loading ? (
                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <CircularProgress size={20} color="inherit" />
                                        <span>Generating...</span>
                                    </Stack>
                                ) : (
                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <GenerateIcon />
                                        <span>Generate Activity</span>
                                    </Stack>
                                )}
                            </Button>
                        </Stack>
                    </Paper>

                    {activity && (
                        <Box sx={{ mt: 4 }}>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                mb: 3,
                                flexDirection: isSmallMobile ? 'column' : 'row',
                                gap: 2
                            }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleDownloadPDF}
                                    sx={{
                                        borderRadius: 2,
                                        backgroundColor: theme.palette.primary.main,
                                        '&:hover': {
                                            backgroundColor: theme.palette.primary.dark,
                                            transform: 'translateY(-2px)',
                                            boxShadow: 4
                                        }
                                    }}
                                >
                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <DownloadIcon />
                                        <span>Download PDF</span>
                                    </Stack>
                                </Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => downloadWordDocument(activity)}
                                    sx={{
                                        borderRadius: 2,
                                        backgroundColor: theme.palette.primary.main,
                                        '&:hover': {
                                            backgroundColor: theme.palette.primary.dark,
                                            transform: 'translateY(-2px)',
                                            boxShadow: 4
                                        }
                                    }}
                                >
                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <DownloadIcon />
                                        <span>Download Word</span>
                                    </Stack>
                                </Button>
                            </Box>

                            <Paper
                                elevation={4}
                                sx={{
                                    p: { xs: 2, sm: 3, md: 4 },
                                    borderRadius: { xs: 1.5, sm: 2, md: 3 },
                                    overflowY: 'auto',
                                    background: theme.palette.background.default,
                                    border: `1px solid ${theme.palette.divider}`,
                                    '@media print': {
                                        borderRadius: 0,
                                        boxShadow: 'none',
                                        margin: 0,
                                        padding: '20px',
                                        maxHeight: 'none',
                                        overflowY: 'visible',
                                        pageBreakInside: 'avoid',
                                        breakInside: 'avoid'
                                    }
                                }}
                            >
                                {renderActivity(activity)}
                            </Paper>
                        </Box>
                    )}

                    <Snackbar
                        open={!!error}
                        autoHideDuration={6000}
                        onClose={() => setError('')}
                    >
                        <Alert severity="error" onClose={() => setError('')}>
                            {error}
                        </Alert>
                    </Snackbar>
                    <AIGenerationLimitDialog
                        open={showLimitDialog}
                        onClose={() => setShowLimitDialog(false)}
                        featureName="Activity Generator"
                        goToUpgrade={() => setActiveTabGlobal?.("Upgrade")}
                    />

                    {/* Professional Error Dialog */}
                    <ValidationErrorDialog
                        open={alertDialog.open}
                        onClose={() => setAlertDialog({ open: false, message: "" })}
                        message={alertDialog.message}
                    />
                </Box>
            </Fade>

            {/* Loading State */}
            {loading && (
                <Box
                    sx={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(255,255,255,0.9)",
                        backdropFilter: "blur(8px)",
                        zIndex: 2000,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Paper
                        elevation={8}
                        sx={{
                            p: { xs: 3, sm: 4 },
                            borderRadius: 4,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            backgroundColor: "white",
                            maxWidth: 400,
                            mx: 2
                        }}
                    >
                        <FloatingGradelyLoader
                            size={60}
                            showText={true}
                            text="Designing engaging classroom activity for your students..."
                        />
                    </Paper>
                </Box>
            )}
        </Container>
    );
};

export default ActivityGenerator;
